import { useTranslation } from 'react-i18next';
import { Page } from '@web/components/page';
import { LitterInsuranceScreen, LitterInsuranceScreenProps } from 'shared/screens/litter-insurance';
import { usePartners } from 'shared/library/partners';
import { withServerProps } from '@web/library/with-server-props';

export default function LitterInsurance(props: LitterInsuranceScreenProps) {
  const { insurancePartner } = usePartners();
  const { t } = useTranslation('screens');

  return (
    <Page
      {...props}
      register={(seo) =>
        seo
          .setTitle(t('litter_insurance.title'))
          .setDescription(t('litter_insurance.description', { partner: insurancePartner.name }))
      }
    >
      <LitterInsuranceScreen {...props} />
    </Page>
  );
}

export const getServerSideProps = withServerProps();
